// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__rP3dU","spin":"loading_spin__OW+R2","flex":"loading_flex__C1sor"};